import React, { useState } from 'react';
import get from 'lodash/get';
import padStart from 'lodash/padStart';
import moment from 'moment';

import { env, lang } from '~/commons/config';
import ListResource from './ListResource.jsx';
import ListCompSelect from './ListCompSelect.jsx';
import { useCompetitions } from '../../contexts/Competitions';

const api = 'api/core/users/students';
const stage = env?.school?.stage;

const ListPerformance = () => {
  const isAdmin = env.user.roles.includes('admin');
  const { find: findComp } = useCompetitions();
  const [compFilter, setCompFilter] = useState({});

  return (
    <ListResource
      {...{
        searchable: [
          { value: 'name', label: 'Name' },
          ...(isAdmin ? [
            { value: 'school.title', label: 'School' },
          ] : []),
          { value: 'schoolClass.title', label: 'Class' },
          {
            value: 'schoolClass.grade',
            label: 'Grade',
            options: Object.keys(env.grades)
              .filter((g) => {
                if (stage === 'p') return g <= 6;
                if (stage === 's') return g >= 7;

                return true;
              })
              .map((g) => ({
                value: g,
                label: env.grades[g].zhhk,
              })),
          },
        ],
        api,
        sort: { 'name.full.en': 1 },
        filter: { ...compFilter },
        actions: {
          find: false,
          create: false,
          remove: false,
          fileExport: 'export-performance',
        },
        ctrls: isAdmin ? [
          <ListCompSelect
            key={0}
            value={compFilter}
            onChange={setCompFilter}
          />,
        ] : [],
        cols: [
          ...(isAdmin ? [
            {
              key: 'school.title.en',
              children: 'School',
              sortable: true,
              getter: (v, r) => lang(get(r, 'school.title')),
            },
          ] : []),
          {
            key: 'name.full.en',
            children: 'Name',
            sortable: true,
            getter: (v, r) => lang(get(r, 'name.full')),
          },
          { key: 'username', sortable: true },
          {
            key: 'schoolClass.grade',
            children: 'Grade',
            sortable: true,
            getter: (v) => get(env.grades, `${v}.zhhk`),
          },
          {
            key: 'schoolClass.title',
            children: 'Class',
            sortable: true,
          },
          {
            key: 'comp.completed',
            children: 'Completed',
            sortable: true,
            getter: (v, r) => (!r?.comp?.startedAt ? 'N' : 'Y'),
          },
          {
            key: 'comp.date',
            children: 'Complete Date',
            sortable: true,
            getter: (v, r) => (!r?.comp?.startedAt
              ? '' : moment(r.comp.startedAt).format('YYYY/MM/DD')),
          },
          {
            key: 'comp.startedAt',
            children: 'Starting Time',
            sortable: true,
            getter: (v) => (!v ? '' : moment(v).format('HH:mm')),
          },
          {
            key: 'comp.endedAt',
            children: 'Complete Time',
            sortable: true,
            getter: (v) => (!v ? '' : moment(v).format('HH:mm')),
          },
          {
            key: 'comp.duration',
            children: 'Time Spent',
            sortable: true,
            getter: (v) => {
              if (!v) return '';

              const d = moment.duration(v, 'ms');

              return `${
                padStart(d.minutes(), 2, 0)
              }:${
                padStart(d.seconds(), 2, 0)
              }.${
                padStart(Math.round(d.milliseconds() / 10), 2, 0)
              }`;
            },
          },

          ...(isAdmin ? [
            {
              key: 'competition',
              sortable: true,
              getter: (v) => findComp(v)?.competition?.refCode,
            },
            {
              key: 'score',
              sortable: true,
            },
            {
              key: 'doublePoint',
              children: 'DoublePoint',
              sortable: true,
              getter: (v) => (v ? `Q${String(v)}` : ''),
            },
          ] : []),
        ],
      }}
    />
  );
};

export default ListPerformance;
